import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core';
import type { Table } from '@tanstack/angular-table';

@Component({
  selector: 'datatable-empty',
  template: `
    <tr
      class="border-b data-[state=selected]:bg-muted hover:bg-muted/50 transition-colors"
    >
      <td
        class="[&:has([role=checkbox])]:pr-0 align-middle p-2 text-center text-muted-foreground"
        [attr.colspan]="colspan()"
      >
        {{ message() }}
      </td>
    </tr>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DatatableEmptyComponent<T = unknown> {
  readonly table = input.required<Table<T>>();
  readonly message = input<string>('Aucune donnée trouvée');

  readonly colspan = computed(() => {
    return this.table().getAllLeafColumns().length;
  });
}
